import { Link } from "react-router-dom";
import Trainer1 from "../../images/trainers/trainer1.png";
import TrainerBg from "../../images/trainers/trainer-bg.png";
import TitleRed from "../../images/who-we-are/title-bg.svg";

function Trainers() {
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section id="training" className="py-[12rem] bg-white relative overflow-hidden">
      <div className="container page-padding">
        <div className="flex flex-col items-center text-center relative mb-24">
          <p className="text-white relative z-10 text-[16px] uppercase font-bold mb-10">
            training services
          </p>
          <img
            src={TitleRed}
            alt="text_bg"
            className="w-[21rem] absolute -top-[6px]"
          />

          <h2 className="text-[3.6rem] font-bold mb-4 uppercase">
            Professional Coaching & Training
          </h2>
          <p className="text-[#646464] font-medium text-[16px] max-w-[65rem]">
            We provide comprehensive training services tailored to your unique fitness level and goals. 
            Our professional approach ensures you get the most out of every workout.
          </p>
        </div>

        <div className="flex items-center gap-[12rem] md1200:flex-col-reverse md1200:gap-[8rem]">
          {/* Content side */}
          <div className="flex flex-col w-[55%] md1200:w-full items-start">
            <h3 className="text-[3.2rem] font-bold mb-8 relative">
              Expert Guidance 
              <span className="block text-red-600">For Your Fitness Journey</span>
              <div className="w-[8rem] h-1 bg-red-600 mt-4 rounded-full"></div>
            </h3>
            
            <p className="text-[#646464] text-[1.8rem] mb-12 leading-relaxed font-medium">
              Our training methodology combines scientific principles with practical experience. 
              Whether you're looking to build muscle, lose weight, or improve athletic performance, 
              we provide the roadmap to your success.
            </p>
            
            {/* Services with subtle stitch-like separators */}
            <div className="grid grid-cols-1 gap-8 mb-14 w-full">
              {[
                { title: "Personal Training", desc: "One-on-one attention for maximum efficiency." },
                { title: "Specialized Nutrition", desc: "Science-backed fuel for your body's needs." },
                { title: "Performance Analysis", desc: "Data-driven insights into your progress." }
              ].map((service, i) => (
                <div key={i} className="flex gap-6 items-start group">
                  <div className="bg-red-600 p-4 rounded-xl text-white shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="fa-solid fa-bolt text-2xl"></i>
                  </div>
                  <div className="flex flex-col border-b border-dashed border-gray-200 pb-4 w-full">
                    <h4 className="text-[2.1rem] font-bold mb-1">{service.title}</h4>
                    <p className="text-[1.6rem] text-[#707070] font-medium">{service.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link 
              to="/contact" 
              onClick={goTop}
              className="relative group bg-black text-white text-[1.6rem] font-bold py-6 px-14 rounded overflow-hidden shadow-2xl transition-all"
            >
              <span className="relative z-10 uppercase tracking-widest">Enquire For Training</span>
              <div className="absolute inset-0 bg-red-600 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300"></div>
            </Link>
          </div>

          {/* Image side - Floating Trainer Image with restored background design */}
          <div className="relative w-[45%] md1200:w-full flex justify-center items-center">
            <div className="relative group flex justify-center items-center">
               {/* Restored Background Design (The red splash/pattern) */}
               <img 
                 src={TrainerBg} 
                 alt="background_design" 
                 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[60%] w-[35rem] transition-transform duration-700 group-hover:scale-110" 
               />
               
               <img 
                 src={Trainer1} 
                 alt="AK Fitness Training" 
                 style={{ clipPath: "inset(0 0 0% 0)" }}
                 className="w-[77rem] h-[70rem] object-cover object-top z-10 relative drop-shadow-2xl grayscale hover:grayscale-0 transition-all duration-700 hover:scale-[1.05]" 
               />
               
               {/* Subtle red glow on hover to enhance the splash */}
               <div className="absolute inset-0 bg-red-600/10 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
            </div>

            {/* Subtle shadow ground */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-48 h-8 bg-black/10 blur-2xl -z-10 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
